import { render } from "./ProspectAiFundamentals.vue?vue&type=template&id=0a3dabb2"
import script from "./ProspectAiFundamentals.vue?vue&type=script&lang=js"
export * from "./ProspectAiFundamentals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__